"use client";
import React from "react";

import Header from "../components/Header";
import CourseDetail from "../components/courses/CourseDetail";
import { useParams } from "react-router-dom";
const CoursePage = () => {
  const { courseId } = useParams();

  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section className="js-page page home " data-router-view="home">
          <CourseDetail courseId={courseId} />
        </section>
      </main>
    </>
  );
};

export default CoursePage;
